import uploadshomeheadimagetjMoorePreviewJpg from "$lib/data/generated/uploads/home/Head/image/tj-moore-preview.jpg";

export const uploads = {
  "uploads/home/Head/image/tj-moore-preview.jpg": uploadshomeheadimagetjMoorePreviewJpg
};